import { useNavigate } from 'react-router-dom';
import { ShieldOff } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext.js';

export function NoAccessPage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="max-w-xl mx-auto mt-20 text-center">
      <div className="inline-flex items-center justify-center w-20 h-20 mb-6 bg-grey-100 rounded-full">
        <ShieldOff className="h-10 w-10 text-grey-500" />
      </div>
      <h1 className="text-3xl font-bold text-grey-700 mb-3">No Access Yet</h1>
      <p className="text-grey-500 mb-2">
        Your account ({user?.email}) is signed in but has no roles assigned.
      </p>
      <p className="text-grey-500 mb-8">
        Please contact an administrator to be granted access.
      </p>
      <button
        onClick={handleSignOut}
        className="px-6 py-3 bg-primary-04 text-white font-semibold rounded-lg hover:bg-primary-600 transition-colors"
      >
        Sign Out
      </button>
    </div>
  );
}
